import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * External dependencies
 */
import { ContextSystemProvider } from '@wp-g2/context';
/**
 * @param {Object} props
 * @param {string[]} [props.__unstableNextInclude]
 * @param {import('react').ReactNode} props.children
 * @param {any} props.value
 */

export function ComponentSystemProvider(_ref) {
  var _ref$__unstableNextIn = _ref.__unstableNextInclude,
      __unstableNextInclude = _ref$__unstableNextIn === void 0 ? [] : _ref$__unstableNextIn,
      children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  if (process.env.COMPONENT_SYSTEM_PHASE === 1) {
    var contextValue = _objectSpread({}, value);

    __unstableNextInclude.forEach(function (namespace) {
      var baseValue = contextValue[namespace] || {};
      contextValue[namespace] = _objectSpread(_objectSpread({}, baseValue), {}, {
        __unstableVersion: 'next'
      });
    });

    return createElement(ContextSystemProvider, {
      value: contextValue
    }, children);
  }

  return children;
}
//# sourceMappingURL=component-system-provider.js.map